'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _eventhub = require('./eventhub');

var _eventhub2 = _interopRequireDefault(_eventhub);

var _App = require('./App.vue');

var _App2 = _interopRequireDefault(_App);

var _mintUi = require('mint-ui');

var _mintUi2 = _interopRequireDefault(_mintUi);

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _vux = require('vux');

var _env = require('./env');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _vueAwesomeSwiper = require('vue-awesome-swiper');

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

var _vueSocket = require('vue-socket.io');

var _vueSocket2 = _interopRequireDefault(_vueSocket);

var _vueInfiniteScroll = require('vue-infinite-scroll');

var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);

require('mint-ui/lib/style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueSocket2.default, _env.host + ':8088', _store2.default);
_vue2.default.use(_vux.ConfirmPlugin);
_vue2.default.use(_vux.ToastPlugin);
_vue2.default.use(_vux.AlertPlugin);
_vue2.default.use(_vueAwesomeSwiper2.default);
_vue2.default.use(_vueInfiniteScroll2.default);
_vue2.default.use(_mintUi2.default);

_vue2.default.config.productionTip = false;
_vue2.default.prototype.$http = _axios2.default;
_vue2.default.prototype.$host = _env.host;
_vue2.default.prototype.$eventhub = _eventhub2.default;

var appVue = new _vue2.default({
    router: _router2.default,
    store: _store2.default,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

_store2.default.commit('set_state');
_store2.default.subscribe(function (mutation, state) {
    localStorage.setItem('state', _qs2.default.stringify(state, { strictNullHandling: true }));
});

var uri = location.href;
var token = uri.match(/token=(\S{34})/) ? uri.match(/token=(\S{34})/)[1] : false;
var pid = uri.match(/pid=(\d*)/) ? uri.match(/pid=(\d*)/)[1] : false;

_axios2.default.defaults.baseURL = _env.host;
_axios2.default.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
_axios2.default.defaults.headers['XPS-Version'] = '1.0.0';
if (token) {
    _router2.default.replace(location.hash.replace(token, '').replace('#', '').replace('token=', ''));
}

_axios2.default.interceptors.request.use(function (config) {
    if (_qs2.default.stringify(config.data)) {
        config.data = _qs2.default.stringify(config.data);
    }
    return config;
}, function (error) {
    return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (response) {
    if (response.data.code == 200) {
        return response.data;
    } else {
        _vue2.default.$vux.alert.show({
            title: response.data.message,
            content: response.data.data
        });
    }
}, function (error) {
    return _promise2.default.reject(error);
});

var FastClick = require('fastclick');
FastClick.attach(document.body);

appVue.$socket.io.skipReconnect = true;

if (pid) {
    _store2.default.commit('set_pid', pid);
}

if (!(_store2.default.state.user && _store2.default.state.token)) {
    if (token) {
        _store2.default.commit('set_token', token);
        _axios2.default.post('/mobile/login/token', { token: token }).then(function (res) {
            _store2.default.commit('set_user', res.data);
            _store2.default.commit('set_token', res.data.token);
            appVue.$socket.emit('login', res.data);
            _axios2.default.defaults.headers['Verify-Token'] = _store2.default.state.token;
        });
    } else {
        _router2.default.push('/');
    }
}

_vue2.default.prototype.msg = function (text) {
    _vue2.default.$vux.toast.show({
        text: text,
        type: 'text'
    });
};

_router2.default.beforeEach(function (to, from, next) {
    if (to.path.indexOf('manage') > 0 && to.path != '/manage/settle' && to.path != '/manage/profile' && !_store2.default.state.user.shop_id) {
        _vue2.default.$vux.toast.show({
            text: '您尚未开通商家服务',
            type: 'text'
        });
        next('/manage/settle');
    }

    if (to.path.indexOf('agent') > 0 && to.path != '/agent/settle' && to.path != '/agent/type' && to.path != '/agent/profile' && !_store2.default.state.user.agent_id) {
        _vue2.default.$vux.toast.show({
            text: '您尚未开通代理商服务',
            type: 'text'
        });
        next('/agent/settle');
    }

    next();
});

Array.prototype.removeByValue = function (val) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] == val) {
            this.splice(i, 1);
            break;
        }
    }
};


// WEBPACK FOOTER //
// ./src/main.js